import React from "react";
import { Link } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import styles from "./SnackBar.module.css";

function SnackBar({ open, message, onClose, actionText, actionLink }) {
  return (
    <Snackbar
      className={styles.snackbar}
      open={open}
      onClose={onClose}
      message={message}
      action={
        <Link className={styles.button} to={actionLink}>
          {actionText}
        </Link>
      }
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    //   sx={{ '& .MuiSnackbar-root': { width: '100%' },
    //         '& .MuiPaper-root': { height: 48, width: '100%'},
    //         '& .MuiSnackbarContent-message': {color: '#fff'} }}
    />
  )
}

export default SnackBar;
